export enum CareCoordinationSubWidget {
  Sdoh = 'SDoH',
  Stars = 'STARs',
  Wcc = 'wound-management'
}

export enum CareCoordinationSubWidgetTab {
  Sdoh,
  Stars,
  Wcc
}
